"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenNotProvided = void 0;
const ApiException_1 = require("./ApiException");
class TokenNotProvided extends ApiException_1.ApiException {
    constructor(message = 'Token not provided.') {
        super(message);
    }
}
exports.TokenNotProvided = TokenNotProvided;
